import React from 'react';
import {connect} from 'react-redux';
import css from './News.module.css';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {newsSet} from "../../store/coreSlice";

const News = (props) => {
	const onClickShowMore = () => {
		const url = props.news.url ? props.news.url : 'https://www.a2pogo.com/n/' + props.news.fancy_url + '.html';
		document.location.href = url;
	};

	const {news} = props;
	return (<Dialog	open={true}>
			<DialogTitle className={css.Title}>{news.title}</DialogTitle>
			<DialogContent>
				{news.text_short && <div className={css.TextShort} dangerouslySetInnerHTML={{__html: news.text_short}} /> }
				{news.text_long && <div className={css.TextLong} dangerouslySetInnerHTML={{__html: news.text_long}} /> }
			</DialogContent>
			<DialogActions>
				<Button onClick={onClickShowMore}>More</Button>
				<Button onClick={() => props.newsSet(null)} color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>);
};


const mapStateToProps = (state) => {
	return {
		news: state.core.news
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		newsSet: (val) => dispatch(newsSet(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(News);